function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.03 22H4a1 1 0 01-.78-1.62 9.3 9.3 0 001.72-3.72C2.44 15.4 0 12.77 0 9.46 0 4.24 5.38 0 12 0s12 4.24 12 9.46C24 14.72 18.62 19 12 19h-1.44c-1.95 2.84-6.33 3-6.53 3zM12 17c5.51 0 10-3.38 10-7.54C22 5.35 17.51 2 12 2S2 5.35 2 9.46c0 2.56 2.2 4.78 4.36 5.64a1 1 0 01.62.93c0 1.33-.47 2.63-.98 3.64 1.16-.32 2.5-.94 3.11-2.13A1 1 0 0110 17h2z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 5C16.43 5 18 6.55 18 8.47c0 .9-.41 1.84-1.1 2.51l-.02.02-.01.02-4.2 3.73-.05.03-.17.11-.07.03-.13.05-.06.01a1 1 0 01-.38 0l-.06-.01a1.03 1.03 0 01-.37-.19l-.04-.03-4.2-3.73-.02-.02-.02-.02A3.64 3.64 0 016 8.47 3.49 3.49 0 019.5 5c.97 0 1.85.38 2.5 1 .65-.62 1.5-.98 2.5-1zM9.48 7C8.66 7 8 7.67 8 8.47c0 .36.2.79.5 1.09l3.5 3.1 3.5-3.1c.3-.3.5-.73.5-1.1 0-.8-.67-1.46-1.5-1.46-.74 0-1.39.51-1.52 1.19l-.04.14-.02.06-.05.1-.04.07-.02.02a1.06 1.06 0 01-.25.25l-.04.02a1.15 1.15 0 01-.15.08h-.04c-.04.03-.09.04-.13.05h-.08A.92.92 0 0112 9l-.12-.01h-.07v-.01a.25.25 0 01-.13-.04l-.07-.02-.1-.06c-.03 0-.05-.02-.07-.03a1 1 0 01-.13-.1l-.02-.02a.97.97 0 01-.11-.14v-.01c-.03-.03-.04-.06-.06-.1l-.04-.07-.02-.06-.04-.13v-.01a1.54 1.54 0 00-1.52-1.2h-.02z"
});

var SvgIconChatHeart = function SvgIconChatHeart(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41
  }, props), _ref, _ref2);
};

export default SvgIconChatHeart;